import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrow2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.28 11.29a.75.75 0 0 1 0 1.06l-6.07 6.07a.75.75 0 1 1-1.06-1.06l4.79-4.79H3.75a.75.75 0 0 1 0-1.5h15.19l-4.79-4.79a.75.75 0 0 1 1.06-1.06l6.07 6.07Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m21.28 11.29-.176.176.176-.176Zm0 1.06-.176-.176.176.176Zm-6.07 6.07-.176-.176.176.176Zm-1.06 0-.177.177.177-.177Zm0-1.06-.177-.177.177.177Zm4.79-4.79v-.25a.25.25 0 0 1 .176.427l-.177-.177Zm-15.19 0v-.25.25Zm0-1.5v-.25.25Zm15.19 0 .176-.177a.25.25 0 0 1-.177.427v-.25Zm-4.79-4.79.176-.176-.176.176Zm0-1.06.176.176-.176-.176Zm1.06 0-.176.176.176-.176Zm6.04 6.6a.5.5 0 0 0-.146-.354l.353-.353a1 1 0 0 1 .293.707h-.5Zm-.146.354a.5.5 0 0 0 .146-.354h.5a1 1 0 0 1-.293.707l-.353-.353Zm-6.07 6.07 6.07-6.07.353.353-6.07 6.07-.353-.353Zm-.708 0a.5.5 0 0 0 .708 0l.353.353a1 1 0 0 1-1.414 0l.353-.353Zm0-.708a.5.5 0 0 0 0 .708l-.353.353a1 1 0 0 1 0-1.414l.353.353Zm4.79-4.79-4.79 4.79-.353-.353 4.79-4.79.353.354ZM3.75 12.32h15.19v.5H3.75v-.5Zm-.5-.5a.5.5 0 0 0 .5.5v.5a1 1 0 0 1-1-1h.5Zm.5-.5a.5.5 0 0 0-.5.5h-.5a1 1 0 0 1 1-1v.5Zm15.19 0H3.75v-.5h15.19v.5Zm-4.614-5.216 4.79 4.79-.353.353-4.79-4.79.353-.353Zm0-.708a.5.5 0 0 0 0 .708l-.353.353a1 1 0 0 1 0-1.414l.353.353Zm.708 0a.5.5 0 0 0-.708 0l-.353-.353a1 1 0 0 1 1.414 0l-.353.353Zm6.07 6.07-6.07-6.07.353-.353 6.07 6.07-.353.353Z"
    />
  </svg>
);
export default SvgArrow2;
